export default __webpack_public_path__ + "//i/components/system-edition//LogoCytric.png";